import React from 'react';
import PageHero from './PageHero';
import { Sparkles, Palette } from 'lucide-react';
import juniorImg from '../assets/JUNIOR SCHOOL.png';

export default function PlayProductionPage({ setPage, t }) {
  const navCategory = t?.nav?.[3]?.label || "School Life";
  const homeLabel = t?.nav?.[0]?.label || "Home";

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen text-ink">
      {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <PageHero
        title="Play Production"
        eyebrow={navCategory}
        subtitle="Bringing stories to life on stage."
        breadcrumbs={[homeLabel, navCategory, "Play Production"]}
        bgImage={juniorImg}
      />

      {/* ── Main Content Container ────────────────────────────────────────── */}
      <div className="max-w-[1200px] mx-auto px-6 lg:px-[80px] py-16 lg:py-24 box-border">

        {/* ── Content Section ── */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 mb-20 lg:mb-28">
          <div className="w-full lg:w-5/12">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold/15 rounded-2xl -z-10" />
              <img
                src={juniorImg}
                alt="Play Production at GMIS Jakarta"
                className="relative z-10 w-full h-[360px] md:h-[420px] rounded-2xl shadow-xl object-cover border-4 border-white"
              />
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-navy/10 rounded-2xl -z-10" />
            </div>
          </div>

          <div className="w-full lg:w-7/12 flex flex-col gap-6 text-left">
            <div>
              <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
                <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">{navCategory}</span>
              </div>
              <h2 className="m-0 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight uppercase">
                Play Production
              </h2>
              <div className="w-16 h-1 bg-gold mt-4" />
            </div>

            <p className="text-[18px] md:text-[20px] font-medium text-navy leading-relaxed">
              Bringing stories to life on stage.
            </p>

            <div className="p-6 rounded-2xl bg-white border border-line shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-gold/15 text-gold-ink flex items-center justify-center shrink-0 mt-0.5">
                  <Sparkles className="w-5 h-5 text-gold-ink" />
                </div>
                <p className="text-[16px] text-ink/80 leading-relaxed m-0">
                  Play Production gives students the opportunity to experience the world of theatre, from performing on stage to working behind the scenes. Students develop confidence, creativity, communication, and teamwork as they work together to bring a production to life.
                </p>
              </div>
            </div>

            <div className="p-6 rounded-2xl bg-white border border-line shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-navy/10 text-navy flex items-center justify-center shrink-0 mt-0.5">
                  <Palette className="w-5 h-5 text-navy" />
                </div>
                <p className="text-[16px] text-ink/80 leading-relaxed m-0">
                  From rehearsals and character development to stage design, costumes, and production, students are involved in the process of creating a performance as a team. It is a chance for students to express themselves, discover their talents, and share their creativity with the wider school community.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ── Concluding Motto Banner ── */}
        <div className="w-full bg-navy rounded-3xl p-10 md:p-14 text-center text-white shadow-xl relative overflow-hidden">
          <div className="w-16 h-1 bg-gold mx-auto mb-6" />
          <h3 className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl leading-snug max-w-3xl mx-auto tracking-tight">
            “A place to perform, create, collaborate, and shine.”
          </h3>
          <div className="mt-8 flex justify-center">
            <button
              onClick={() => {
                if (setPage) setPage('contact');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-8 py-3.5 rounded-lg bg-gold text-navy font-heading font-bold text-xs uppercase tracking-widest hover:bg-gold/90 transition-all shadow-md"
            >
              Contact Us
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
